import { render, staticRenderFns } from "./sleep.vue?vue&type=template&id=b62af704"
import script from "./sleep.vue?vue&type=script&lang=js"
export * from "./sleep.vue?vue&type=script&lang=js"
import style0 from "./sleep.vue?vue&type=style&index=0&id=b62af704&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports